import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { BaseIntegrationForm } from './BaseIntegrationForm';
import { useIntegrationForm } from '@/hooks/useIntegrationForm';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

export function LeadloversForm() {
  useLanguage();
  const { selectedVideo, setSelectedVideo, videos, isLoadingVideos, handleSubmit, isSubmitting } =
    useIntegrationForm('leadlovers', 'Leadlovers', 'leads');

  const [formData, setFormData] = useState({
    endpoint_url: '',
    machine_code: '',
    sequence_level_code: '',
    email_sequence_code: '',
    api_key: '',
  });

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await handleSubmit({
      ...formData,
      id_video: selectedVideo?.id || '',
    });
  };

  const handleChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  if (isLoadingVideos) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-gray-500" />
      </div>
    );
  }

  return (
    <BaseIntegrationForm onSubmit={onSubmit}>
      <div className="space-y-2">
        <Label htmlFor="endpoint_url" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Webhook URL")}</Label>
        <Input
          id="endpoint_url"
          name="endpoint_url"
          type="url"
          placeholder="https://api.leadlovers.com/webhook/..."
          value={formData.endpoint_url}
          onChange={(e) => handleChange('endpoint_url', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="machine_code" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Código da Máquina")}</Label>
        <Input
          id="machine_code"
          name="machine_code"
          type="text"
          placeholder="1234"
          value={formData.machine_code}
          onChange={(e) => handleChange('machine_code', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="sequence_level_code" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Código do Funil")}</Label>
        <Input
          id="sequence_level_code"
          name="sequence_level_code"
          type="text"
          placeholder="5678"
          value={formData.sequence_level_code}
          onChange={(e) => handleChange('sequence_level_code', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email_sequence_code" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Código de E-mail")}</Label>
        <Input
          id="email_sequence_code"
          name="email_sequence_code"
          type="text"
          placeholder="9012"
          value={formData.email_sequence_code}
          onChange={(e) => handleChange('email_sequence_code', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="api_key" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Token")}</Label>
        <Input
          id="api_key"
          name="api_key"
          type="text"
          placeholder="seu_token_leadlovers"
          value={formData.api_key}
          onChange={(e) => handleChange('api_key', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="video" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Selecione o Vídeo")}</Label>
        <Select
          value={selectedVideo?.id || ''}
          onValueChange={(value) => {
            const video = videos.find((v) => v.id === value);
            if (video) setSelectedVideo(video);
          }}
        >
          <SelectTrigger className="h-10">
            <SelectValue placeholder={translateInterfaceText("Escolha um vídeo")} />
          </SelectTrigger>
          <SelectContent>
            {videos.map((video) => (
              <SelectItem key={video.id} value={video.id}>
                {video.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {isSubmitting && (
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>{translateInterfaceText("Salvando...")}</span>
        </div>
      )}
    </BaseIntegrationForm>
  );
}
